import { render, staticRenderFns } from "./EnacAtplDashboardPhaseItemDetails.vue?vue&type=template&id=353b1183"
import script from "./EnacAtplDashboardPhaseItemDetails.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardPhaseItemDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports